module.exports = __webpack_public_path__ + "img/sendM.0aa60390.svg";